import React, { useEffect, useState } from "react";
import QuotesPage from "../../../../../entities/DashboardPage/AccountingModule/Quotes";
import LoaderHelper from "../../../../../utils/Loader/LoaderHelper";
import AuthService from "../../../../../api/AuthService";
import { useAlert } from "../../../../../context/AlertContext";

const Quotes = () => {
  const [data, setData] = useState([])
  const {showAlert} = useAlert();
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    getAllQuotes("", "", currentPage)
  }, [])

  const getAllQuotes = async (text, sort, page) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.handleGetAllQuoteData(text, sort, page);
      if (result?.success) {
        setData(result?.data?.qoutes);
        setTotal(result.data.total)
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };
  const handleDelete = async (id) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.handleDeleteQuote(id);
      if (result?.success) {
        getAllQuotes()
        LoaderHelper.loaderStatus(false);
        showAlert(result.message, "success")
      } else {
        showAlert(result.message, "error")
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };
  return (
    <QuotesPage 
      data={data}
      handleDelete={handleDelete} 
      total={total}
      setTotal={setTotal}
      currentPage={currentPage}
      setCurrentPage={setCurrentPage}
      rowsPerPage={rowsPerPage}
      setRowsPerPage={setRowsPerPage}
    />
  )
}

export default Quotes;